import React from "react";

import { useNavigate } from "react-router-dom";

function MailCongfig() {
  const navigate = useNavigate();
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-[#7B20C7] text-2xl ">Smtp mail config</h1>
          </div>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={(e) => e.preventDefault()} >
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full">

              <label htmlFor="" className="w-full lg:w-1/4 ">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Email Status
                </span>
                <div className="mb-2 pt-0">
                  <input  type="radio" name="Email" id="Email" value="Email" checked />
                  <label className="form-check-label ps-2 pe-3 text-[#7B20C7] text-sm mb-2 " for="Active">
                    Active
                  </label>
                  <input className="ps-5 form-check-input" type="radio" name="Inactive"
                    id="Inactive" value="Inactive " />
                  <label className="form-check-label  ps-2 pe-3 text-[#7B20C7] text-sm mb-2 " for="exampleRadios2">
                    Inactive
                  </label>
                </div>
              </label>
            </div>
          
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                Mailer name
                </span>
                <div className="mb-2 pt-0">
                  <input type="text" placeholder="Imdady Demo Account"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
               
              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                Driver 
                </span>
                <div className="mb-2 pt-0">
                  <input type="text" placeholder="SMTP"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
              User
                </span>
                <div className="mb-2 pt-0">
                  <input type="text" placeholder="info@imdadyrms.com"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            


            </div>

            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                Password 
                </span>
                <div className="mb-2 pt-0">
                  <input type="text" placeholder="*********"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
               
              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                Host  
                </span>
                <div className="mb-2 pt-0">
                  <input type="text" placeholder="mail.imdadyrms.com"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                Port 
                </span>
                <div className="mb-2 pt-0">
                  <input type="text" placeholder="456"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            


            </div>

            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                Protocol  
                </span>
                <div className="mb-2 pt-0">
                  <input type="text" placeholder="SSL"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
  
            </div>

        

            <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="submit"
              >
                Submit
              </button>
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default MailCongfig;
